import { BlipPortalUri, portalDomain } from '../app/app.constants';
import { captureConsoleIntegration, httpClientIntegration, replayIntegration } from '@sentry/browser';
import { mfesConfigs, settings } from '../app/app.constants';

let sentryInit;

/**@description load sentry CDN into HTML Header */
export const startSentry = async (sentryData) => {
    sentryInit = sentryData.init;
    
    window.sentryOnLoad = () => {
        initSentry();
        setContextData();
    };

    const sentry = document.createElement('script');
    sentry.src = sentryData.ingest;
    sentry.crossOrigin = 'anonymous';
    document.head.appendChild(sentry);

};

const initSentry = () => {
    const replay = replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
    });
    const domain = String(portalDomain);
    const isDevelopment = domain.includes('localhost') || domain.includes('localdev.me');
    const clusterName = String(BlipPortalUri).replace('https://', '').split('.')[0];
    Object.assign(sentryInit, {
        environment: isDevelopment ? 'development' : clusterName,
        integrations: isDevelopment ? [] : [
            captureConsoleIntegration({levels: ['error']}),
            httpClientIntegration(),
            replay,
        ],
        beforeSend: (event) => {
            const sentryFilterMfeErrorsEnabled = settings && settings.sentryFilterMfeErrors || false;
            if (!sentryFilterMfeErrorsEnabled || !event.exception || !event.exception.values) {
                return event;
            }

            const values = event.exception.values;

            if (values && values[0] && values[0].stacktrace) {
                let stacktraceString = '';
                if (!values[0].stacktrace) {
                    return event;
                }
                for (const frame of values[0].stacktrace.frames || []) {
                    stacktraceString += frame.filename + '';
                }
                if (isMfeError(stacktraceString)) {
                    return null;
                }
            }
            return event;
        },
    });
    window.Sentry.init(sentryInit);
};

const isMfeError = (stacktraceString) => {
    for (const mfesConfig of Object.keys(mfesConfigs)) {
        const mfe = mfesConfigs[mfesConfig];
        if (mfe.uncachedScriptURI && stacktraceString.includes(mfe.uncachedScriptURI)) {
            return true;
        }
    }
    return false;
};

const setContextData = () => {
    window.Sentry.setUser({
        id: localStorage.getItem('apc_user_id'),
    });
};